import { render, staticRenderFns } from "./ConsolidaPedidos.vue?vue&type=template&id=98983ee0&scoped=true"
import script from "./ConsolidaPedidos.vue?vue&type=script&lang=js"
export * from "./ConsolidaPedidos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98983ee0",
  null
  
)

export default component.exports